import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../common/types';
import styles from './EmbedSheetFooter.module.scss';

interface EmbedSheetFooterProps {
  onOpenEmbed: () => void;
  onDone: () => void;
}

/** What the artist keeps after closing the sheet, said in one line. */
const EmbedSheetFooterComponent: React.FC<EmbedSheetFooterProps> = ({ onOpenEmbed, onDone }) => {
  const intl = useIntl();

  return (
    <div className={styles.foot}>
      <p className={styles.note}>
        {intl.formatMessage({
          id: 'app.sml.embed.footer.note',
          defaultMessage:
            'The widget always shows the live page. Change a service or the artwork and every embed updates.',
        })}
      </p>
      <button type="button" className={styles.secondary} onClick={onOpenEmbed}>
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        {intl.formatMessage({ id: 'app.sml.embed.test', defaultMessage: 'Test page' })}
      </button>
      <button type="button" className={styles.primary} onClick={onDone}>
        {intl.formatMessage({ id: 'app.sml.embed.done', defaultMessage: 'Done' })}
      </button>
    </div>
  );
};

export const EmbedSheetFooter = TypedMemo(EmbedSheetFooterComponent);
